import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function BrowserIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M20.25 3.938H6.75a1.313 1.313 0 0 0-1.313 1.313v1.688H3.75a1.313 1.313 0 0 0-1.313 1.313v10.5a1.313 1.313 0 0 0 1.313 1.313h13.5a1.313 1.313 0 0 0 1.313-1.313v-1.688h1.687a1.313 1.313 0 0 0 1.313-1.313v-10.5a1.313 1.313 0 0 0-1.313-1.313ZM3.75 8.063h13.5a.188.188 0 0 1 .188.188v1.688H3.563V8.25a.188.188 0 0 1 .188-.188Zm13.688 10.688a.188.188 0 0 1-.188.188H3.75a.188.188 0 0 1-.188-.188v-7.688h13.875v7.687Zm3-3a.188.188 0 0 1-.188.188h-1.688V8.25a1.313 1.313 0 0 0-1.313-1.313H6.563V5.25a.188.188 0 0 1 .188-.188h13.5a.188.188 0 0 1 .188.188v10.5Z"
        fill="currentColor" />
    </BaseIcon>
  )
}
